import React from "react";
import { units } from '../../helpers';
import "./Input.scss";

const Input = ({ settings, setSettings }) => {
  const handleChange = (property, value) => {
    let newSettings = {
      ...settings,
      [property]: value,
    };

    setSettings(newSettings);
  };

  return (
    <div className="input">
      <div className="fields">
        <input
          type="text"
          value={settings.firstLabel}
          onChange={(e) => handleChange("firstLabel", e.target.value)}
          placeholder="Enter title"
        />
      </div>
      <div className="fields">
        <input
          type="number"
          value={settings.firstValue}
          min={1}
          onChange={(e) => handleChange("firstValue", e.target.value)}
          placeholder="Enter size"
        />
        <select
          value={settings.firstUnit}
          onChange={(e) => handleChange("firstUnit", e.target.value)}
        >
          {units.map((unit) => (
            <option key={unit.unit} value={unit.unit}>
              {unit.name} ({unit.unit})
            </option>
          ))}
        </select>
      </div>
      <div className="fields">
        <input
          type="text"
          value={settings.secondLabel}
          onChange={(e) => handleChange("secondLabel", e.target.value)}
          placeholder="Enter title"
        />
      </div>
      <div className="fields">
        <input
          type="number"
          value={settings.secondValue}
          min={1}
          onChange={(e) => handleChange("secondValue", e.target.value)}
          placeholder="Enter size"
        />
        <select
          value={settings.secondUnit}
          onChange={(e) => handleChange("secondUnit", e.target.value)}
        >
          {units.map((unit) => (
            <option key={unit.unit} value={unit.unit}>
              {unit.name} ({unit.unit})
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Input;
